import { Link } from 'react-router-dom'
import { ReactNode } from 'react'

interface ButtonProps {
    children: ReactNode
    variant?: 'primary' | 'secondary' | 'ghost'
    size?: 'sm' | 'md' | 'lg'
    to?: string
    href?: string
    onClick?: () => void
    className?: string
    type?: 'button' | 'submit'
    disabled?: boolean
}

export default function Button({
    children,
    variant = 'primary',
    size = 'md',
    to,
    href,
    onClick,
    className = '',
    type = 'button',
    disabled = false,
}: ButtonProps) {
    const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-full transition-all whitespace-nowrap'

    const variantStyles = {
        primary: 'btn-primary',
        secondary: 'glass hover:bg-white/75 text-primary-color shadow-glass',
        ghost: 'text-primary-base hover:text-primary-darker',
    }

    const sizeStyles = {
        sm: 'px-4 py-2 text-sm',
        md: 'px-6 py-3 text-base',
        lg: 'px-8 py-4 text-lg',
    }

    const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : ''

    const combinedStyles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${className}`

    if (to) {
        return (
            <Link to={to} className={combinedStyles}>
                {children}
            </Link>
        )
    }

    if (href) {
        return (
            <a href={href} className={combinedStyles}>
                {children}
            </a>
        )
    }

    return (
        <button type={type} onClick={onClick} className={combinedStyles} disabled={disabled}>
            {children}
        </button>
    )
}

